export const STATUS_REFUND = {
  review: {
    label: 'Menunggu Review',
    color: '#000',
    bg: 'softBlue',
  },
  rejected: {
    label: 'Refund Ditolak',
    color: '#FF3B30',
    bg: 'lightDanger',
  },
  approved: {
    label: 'Refund Disetujui',
    color: '#000',
    bg: 'softGreen',
  },
  shipped: {
    label: 'Dikirim',
    color: '#000',
    bg: 'softBlue',
  },
  arrived: {
    label: 'Barang Sampai',
    color: '#000',
    bg: 'softBlue',
  },
  processing: {
    label: 'Refund Diproses',
    color: '#000',
    bg: 'softBlue',
  },
  finished: {
    label: 'Refund Selesai',
    color: '#000',
    bg: 'softGreen',
  },
};

export type RefundStatusType = keyof typeof STATUS_REFUND;
